document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".custom-select").forEach((select) => {
    const trigger = select.querySelector(".select-trigger");
    const hiddenInput = select.querySelector('input[type="hidden"]');

    trigger.addEventListener("click", function () {
      document.querySelectorAll(".custom-select").forEach((item) => {
        if (item !== select) {
          item.classList.remove("active");
        }
      });

      select.classList.toggle("active");
    });

    select.querySelectorAll(".select-options li").forEach((option) => {
      option.addEventListener("click", function () {
        trigger.textContent = this.textContent.trim();

        hiddenInput.value = this.dataset.value;

        select.classList.remove("active");
      });
    });
  });

  document.addEventListener("click", function (e) {
    if (!e.target.closest(".custom-select")) {
      document.querySelectorAll(".custom-select").forEach((select) => {
        select.classList.remove("active");
      });
    }
  });

  $(".customer-review-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false, // using custom arrows below
    dots: false,
    infinite: true,
    speed: 500,
    fade: false,
    cssEase: "ease-in-out",
    adaptiveHeight: true,
  });

  $(".arrow-prev").on("click", function () {
    $(".customer-review-slider").slick("slickPrev");
  });

  $(".arrow-next").on("click", function () {
    $(".customer-review-slider").slick("slickNext");
  });

  document.querySelectorAll(".floating-field input").forEach((input) => {
    function toggleLabel() {
      input.parentElement.classList.toggle(
        "has-value",
        input.value.trim() !== "",
      );
    }

    input.addEventListener("input", toggleLabel);
    toggleLabel(); // initial check
  });
});
